<div class="col-12">
  <div class="card">
    <div class="card-body ">
      <div class="tab-content">
        <div class="tab-pane active" id="link10">
          <ul class="nav nav-pills nav-pills-rose nav-pills-icons justify-content-center" role="tablist">
            <li [class.active]="param.editPasswordForced || param.editPassword" class="nav-item">
              <a class="nav-link" [class.active]="param.editPasswordForced || param.editPassword" [routerLink]="" (click)="param.editPassword = true;param.editProfil = false;param.editJobalert = false;param.editPj=false;param.editReponse = false;param.editStatus = false;" data-toggle="tab" role="tablist">
                <i class="material-icons">security</i> Modifier mon  mot de passe
              </a>
            </li>
            <li [class.active]="param.editProfil" class="nav-item">
              <a class="nav-link" [class.active]="param.editProfil" [class.disabled]="param.editPasswordForced" [routerLink]="" (click)="param.editProfil = true;param.editPassword = false;param.editJobalert = false;param.editPj=false;param.editReponse = false;param.editStatus = false;" data-toggle="tab" role="tablist">
                <i class="material-icons">description</i> Modifier mon Profil
              </a>
            </li>
            <li [class.active]="param.editStatus" class="nav-item">
              <a class="nav-link" [class.active]="param.editStatus" [class.disabled]="param.editPasswordForced" [routerLink]="" (click)="param.editProfil = false;param.editPassword = false;param.editJobalert = false;param.editPj=false;param.editReponse = false;param.editStatus = true;" data-toggle="tab" role="tablist">
                <i class="material-icons">favorite_border</i> Statut de mon compte
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

